import { render, staticRenderFns } from "./charge-inactivated-instances-card.component.vue?vue&type=template&id=756eb689&scoped=true&"
import script from "./charge-inactivated-instances-card.component.vue?vue&type=script&lang=ts&"
export * from "./charge-inactivated-instances-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./charge-inactivated-instances-card.component.vue?vue&type=style&index=0&id=756eb689&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756eb689",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
